import { useState, useEffect, useRef } from "react";
import { RefreshCw, ImageOff } from "lucide-react";

const STALL_MS = 25000;

export const SmartImg = ({ src, retries = 4, retryLabel = "Foto opnieuw laden", className = "", onFail, ...props }) => {
  const [attempt, setAttempt] = useState(0);
  const [failed, setFailed] = useState(false);
  const doneRef = useRef(false);
  useEffect(() => { setAttempt(0); setFailed(false); }, [src]);
  const url = attempt > 0 ? `${src}${src.includes("?") ? "&" : "?"}r=${attempt}` : src;

  useEffect(() => {
    if (failed) return undefined;
    doneRef.current = false;
    const t = setTimeout(() => {
      if (doneRef.current) return;
      if (attempt < retries) setAttempt((a) => a + 1);
      else { setFailed(true); onFail?.(); }
    }, STALL_MS);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, failed]);

  if (failed) {
    return (
      <button type="button" data-testid="img-retry-button"
        onClick={() => { setFailed(false); setAttempt((a) => a + 1); }}
        className={`bg-secondary flex flex-col items-center justify-center gap-1.5 text-muted-foreground min-h-[96px] ${className}`}>
        <ImageOff className="w-5 h-5" />
        <span className="text-[11px] font-semibold flex items-center gap-1"><RefreshCw className="w-3 h-3" /> {retryLabel}</span>
      </button>
    );
  }
  return (
    <img src={url} {...props} className={className}
      onLoad={(e) => { doneRef.current = true; props.onLoad?.(e); }}
      onError={() => {
        doneRef.current = true;
        if (attempt < retries) setTimeout(() => setAttempt(attempt + 1), 700 * (attempt + 1));
        else { setFailed(true); onFail?.(); }
      }} />
  );
};
